<template>
  <footer class="sticky-footer py-4 bg-dark">
    <div class="container my-auto">
      <div class="copyright text-center my-auto">
        <span>Copyright &copy; <a href="www.orangestar.com">Orange Star S.A.S</a></span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>



// WEBPACK FOOTER //
// src/layouts/Footer.vue